const styleConstants = {
  // https://polaris.shopify.com/design/spacing#navigation
  spacing: {
    one: '4px',
    two: '8px',
    three: '12px',
    four: '16px',
    five: '20px',
    six: '32px',
  },
  color: {
    white: '#ffffff',
    lightGrey: '#f9fafb',
  },
  containerWidth: '996px',
};

export default styleConstants;
